const FilterData = [
  {
    value: 'All',
    label: 'All Filters',
  },
  {
    value: 'Transaction',
    label: 'Txn Hash',
  },
  {
    value: 'Block',
    label: 'Number',
  },
];

export default FilterData;
